import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { Upload, message } from "antd";
import type { RcFile, UploadChangeParam, UploadFile } from "antd/lib/upload";
import XtLoading from "@/components/Xt/Loading";
interface UploadProps extends BaseCompProps {
  attr?: any;
  action?: string;
  type?: string;
  name?: string;
  params?: string;
  limit?: number | string;
  accept?: string;
  /** 当前值（如表单中的 videoUrl），有值时显示已上传状态并隐藏父级占位背景 */
  value?: string;
  onChangeImg?(params: string, resData: any): void;
}
const { useTranslation } = Hooks;
const AuthUpload: React.FC<UploadProps> = ({
  attr,
  className,
  action = "/exchange-user/api/web/1_0_0/uploadFile",
  type = "img",
  name = "file",
  params = "",
  limit = 10240,
  accept = ".jpg,.png,.jpeg,.svg,.gif,.webp",
  value: valueProp,
  onChangeImg,
}) => {
  const t = useTranslation();
  const { token } = store.user;
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | ArrayBuffer | null>("");
  const [file, setFile] = useState({} as RcFile);

  const imgType = useMemo(() => {
    return attr?.imgType;
  }, [attr]);
  /** useMemo */
  const getHeaders = useMemo(() => {
    return {
      token,
      device: "web",
      Authorization: `Bearer ` + token,
    };
  }, [token]);
  const getBase64 = (img: File, callback: (imageUrl: string | ArrayBuffer | null) => void) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    if (info.file.status === "uploading") {
      return setLoading(true);
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj!, (imageUrl) => {
        setImageUrl(imageUrl);
        if (params == "authImg") {
          onChangeImg && onChangeImg(params, info.file.response?.data?.absolutePath || "");
        } else {
          onChangeImg && onChangeImg(params, info.file.response?.data[0] || "");
        }
        setLoading(false);
      });
    }
  };

  const beforeUpload = (file: RcFile) => {
    const isMb = limit && limit == 5120 ? 5120 : 51200;
    const isLt2M = file.size / 1024 < isMb;
    setFile(file);
    if (!isLt2M) message.error(t("account.notAllowed", [isMb]));
  };
  return (
    <div className={cx(styles.auth_upload, className)}>
      <Upload
        className={styles["uploadAuth"]}
        showUploadList={false}
        action={action}
        name={name}
        onChange={handleChange}
        accept={accept}
        beforeUpload={beforeUpload}
        headers={getHeaders}
      >
        {type == "img" ? (
          <div className={styles["img_S"]}>
            {imageUrl ? (
              <div className={styles["imgurl_class"]}>
                <img
                  className={styles["realimg"]}
                  src={imageUrl as string}
                  alt="avatar"
                  onError={() => {
                    onChangeImg && onChangeImg(params, "");
                  }}
                />
              </div>
            ) : (
              <div className={styles["upload_icon"]}>
                {loading ? (
                  <XtLoading />
                ) : (
                  <img
                    className={cx(styles["ll-add-icon"], imgType ? styles["kyc"] : "")}
                    src={imgType ? require("@/assets/images/account/updatafile.png") : require("@/assets/images/account/a-file-add.png").default}
                    alt="images"
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <div>
            {imageUrl || valueProp ? (
              <div className={cx(styles["imgurl_class"], styles["imgurl_class_video"])}>
                <div style={{ textAlign: "center" }}>
                  <img src={require("@/assets/images/account/videos.png").default} alt="avatar" />
                  <p style={{ marginTop: "10px" }}>{file?.name || (valueProp ? (valueProp.split("/").pop() || valueProp) : "")}</p>
                </div>
              </div>
            ) : (
              <div className={styles["upload_icon"]}>
                {loading ? (
                  <XtLoading />
                ) : (
                  <img className={styles["ll-add-icon"]} src={require("@/assets/images/account/a-file-add.png").default} alt="video" />
                )}
              </div>
            )}
          </div>
        )}
      </Upload>
    </div>
  );
};
export default observer(AuthUpload);
